import moment from 'moment-timezone'
import { FORMATS } from 'constants/datetime'

export const formatMileageCriteria = (rangeStart?: string, rangeEnd?: string) => {
  if (!rangeStart) {
    return `Less than ${rangeEnd} miles`
  }
  if (!rangeEnd) {
    return `More than ${rangeStart} miles`
  }
  return `Between ${rangeStart} and ${rangeEnd} miles`
}

export const formatTransitDifferenceCriteria = (
  timeUnit: string,
  timeRangeStart?: string,
  timeRangeEnd?: string
) => {
  if (!timeRangeStart) {
    return `Less than ${timeRangeEnd} ${timeUnit}s`
  }
  if (!timeRangeEnd) {
    return `More than ${timeRangeStart} ${timeUnit}s`
  }
  return `Between ${timeRangeStart} and ${timeRangeEnd} ${timeUnit}s`
}

export const formatCountLoadsQuotedCriteria = (
  pickupValue: string,
  deliveryValue: string,
  rangeStart?: string,
  rangeEnd?: string,
  isSamePickupDelivery?: boolean,
  isDifferentPickupDelivery?: boolean
) => {
  let formattedString = `${pickupValue} - ${deliveryValue}`
  if (isSamePickupDelivery) {
    formattedString = formattedString.concat(`, same PU/DEL,`)
  }
  if (isDifferentPickupDelivery) {
    formattedString = formattedString.concat(`, different PU/DEL,`)
  }
  if (!rangeStart) {
    return formattedString.concat(` less than ${rangeEnd} opportunities quoted`)
  }
  if (!rangeEnd) {
    return formattedString.concat(` ${rangeStart} or more opportunities quoted`)
  }
  return formattedString.concat(` between ${rangeStart} and ${rangeEnd} opportunities quoted`)
}

export const formatDistanceToMarketCenterCriteria = (rangeStart?: string, rangeEnd?: string) => {
  if (!rangeStart) {
    return `Less than ${rangeEnd} miles`
  }
  if (!rangeEnd) {
    return `More than ${rangeStart} miles`
  }
  return `Between ${rangeStart} and ${rangeEnd} miles`
}

export const formatDateCriteria = (rangeStart: string, rangeEnd: string) => {
  const start = moment(rangeStart).format(FORMATS.dateFormatShort)
  const end = moment(rangeEnd).format(FORMATS.dateFormatShort)
  if (start === end) {
    return start
  }
  return `${start} to ${end}`
}

export const formatNumDaysOut = (rangeStart: string, rangeEnd: string) => {
  const numDaysOutStart = Number(rangeStart) > 23 ? Number(rangeStart) / 24 : Number(rangeStart)
  const numDaysOutEnd = Number(rangeEnd) > 23 ? Number(rangeEnd) / 24 : Number(rangeEnd)

  let qualifier
  let numDaysOut
  if (numDaysOutStart === 0) {
    qualifier = 'Less than'
    numDaysOut = numDaysOutEnd
  } else if (numDaysOutEnd - numDaysOutStart === 1) {
    qualifier = 'Exactly'
    numDaysOut = numDaysOutStart
  } else {
    qualifier = 'More than'
    numDaysOut = numDaysOutStart - 1
  }
  if (Number(rangeStart) < 24 && Number(rangeEnd) < 24) {
    return numDaysOut === 1
      ? `${qualifier} ${numDaysOut} hour out`
      : `${qualifier} ${numDaysOut} hours out`
  }
  return numDaysOut === 1
    ? `${qualifier} ${numDaysOut} day out`
    : `${qualifier} ${numDaysOut} days out`
}
